import {HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
import {AppVersion} from '@ionic-native/app-version';
import {MyApp} from './app.component';
import {createTranslateLoader} from "../factories/translate.loader.factory";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {ManageTagsPageModule} from "../pages/manage-tags/manage-tags.module";
import {ChangeStatusPageModule} from "../pages/change-status/change-status.module";
import {CycleCountPageModule} from "../pages/cycle-count/cycle-count.module";
import {AppConfigPageModule} from "../pages/app-config/app-config.module";
import {IdentifyTagPageModule} from "../pages/identify-tag/identify-tag.module";
import {LoginPageModule} from "../pages/login/login.module";
import {SetupPageModule} from "../pages/setup/setup.module";
import {ConfigPageModule} from "../pages/config/config.module";
import {IonicStorageModule} from "@ionic/storage";
import {MenuTrackerRetailPageModule} from '../pages/menu-tracker-retail/menu-tracker-retail.module';
import {VizixService} from "../providers/vizix.service";
import {InstructionsPageModule} from '../pages/instructions/instructions.module';
import {FindItemPageModule} from "../pages/find-item/find-item.module";
import {UnassociatedTagsPageModule} from "../pages/unassociated-tags/unassociated-tags.module";
import {VizixClientModule} from "vizixc/dist";
import {DeviceSelectPageModule} from "../pages/device-select/device-select.module";
import {ReaderService} from "../providers/reader.service";
import {DialogCustomPageModule} from "../pages/dialog-custom/dialog-custom.module";
import {PopoverProductStatusPageModule} from "../pages/popover-product-status/popover-product-status.module";
import {ComponentsModule} from "../components/components.module";
import {SplashPageModule} from "../pages/splash/splash.module";
import {File} from "@ionic-native/file";
import {AndroidPermissions} from "@ionic-native/android-permissions";
import {CycleCountService} from '../providers/cyclecount.service';
import {SimulatorService} from '../providers/simulator.service';
import {ConfigurationService} from '../providers/configuration.service';
import {Keyboard} from '@ionic-native/keyboard';
import {Network} from "@ionic-native/network";
import {SQLite} from "@ionic-native/sqlite";
import {Device} from '@ionic-native/device';
import {PopoverCyclecountDetailsModule} from "../pages/popover-cyclecount-details/popover-cyclecount-details.module";
import {NativeAudio} from "@ionic-native/native-audio";
import {PopoverCyclecountProgressPageModule} from "../pages/popover-cyclecount-progress/popover-cyclecount-progress.module";
import {PopoverCyclecountGeigerPageModule} from "../pages/popover-cyclecount-geiger/popover-cyclecount-geiger.module";
import {DirectivesModule} from "../directives/directives.module";
import {PopoverDetailsPageModule} from "../pages/popover-details/popover-details.module";
import {UniqueDeviceID} from "@ionic-native/unique-device-id";
import {VizixEventService} from "../providers/vizix.event.service";
import {BarcodeScanner} from "@ionic-native/barcode-scanner";
import {RootPageModule} from "../pages/root/root.module";
import {ReplenishmentPageModule} from "../pages/replenishment/replenishment.module";
import {FindItemService} from "../providers/find.item.service";
import {LookUpPageModule} from "../pages/look-up/look-up.module";
import {ConfigurationFileService} from "../providers/configuration.file.service";
import {Insomnia} from "@ionic-native/insomnia";
import {InsomniaService} from "../providers/insomnia.service";
import {HeaderTitleComponentModule} from '../components/header-title/header-title.module'
import {PopoverUnassociatedProgressPageModule} from '../pages/popover-unassociated-progress/popover-unassociated-progress.module';
import {UnassociatedService} from '../providers/unassociated.service';
import {ReplenishmentService} from "../providers/replenishment.service";
import {EncodeTagsPageModule} from '../pages/encode-tags/encode-tags.module';
import {EncodeTagsService} from "../providers/encode.tags.service";
import {VirtualScrollModule} from "angular2-virtual-scroll";
import {PopoverSelectDepartmentPageModule} from "../pages/popover-select-department/popover-select-department.module";
import {TagInformationService} from "../providers/tag.information.service";
import {NetworkInformationService} from '../providers/network.information.service';
import {EPCSequenceThingService} from "../providers/epc.sequence.thing.service";

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    LoginPageModule,
    SetupPageModule,  // SetupModel VizixURL, login
    ConfigPageModule,    // SetupModel ConfigurationThing and language
    ReplenishmentPageModule,
    SplashPageModule,
    MenuTrackerRetailPageModule,
    ManageTagsPageModule,
    ChangeStatusPageModule,
    CycleCountPageModule,
    AppConfigPageModule,
    InstructionsPageModule,
    FindItemPageModule,
    LookUpPageModule,
    IdentifyTagPageModule,
    DeviceSelectPageModule,
    DialogCustomPageModule,
    PopoverProductStatusPageModule,
    PopoverCyclecountDetailsModule,
    PopoverCyclecountProgressPageModule,
    PopoverUnassociatedProgressPageModule,
    PopoverSelectDepartmentPageModule,
    PopoverCyclecountGeigerPageModule,
    PopoverDetailsPageModule,
    UnassociatedTagsPageModule,
    EncodeTagsPageModule,
    RootPageModule,
    HeaderTitleComponentModule,
    HttpClientModule,
    BrowserModule,
    VirtualScrollModule,


    IonicModule.forRoot(MyApp, {
      activator: "ripple",
      scrollPadding: false,
      scrollAssist: true,
      autoFocusAssist: true
    }),

    VizixClientModule.forRoot(),

    IonicStorageModule.forRoot({
      name: 'tracker_retail'
    }),

    ComponentsModule,
    DirectivesModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    SQLite,
    VizixService,
    NetworkInformationService,
    ReaderService,
    CycleCountService,
    ReplenishmentService,
    UnassociatedService,
    VizixEventService,
    FindItemService,
    EncodeTagsService,
    EPCSequenceThingService,
    SimulatorService,
    ConfigurationService,
    TagInformationService,
    StatusBar,
    SplashScreen,
    AndroidPermissions,
    Insomnia,
    InsomniaService,
    ConfigurationFileService,
    Keyboard,
    NativeAudio,
    AppVersion,
    UniqueDeviceID,
    File,
    Network,
    BarcodeScanner,
    Device,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts